var angular = require('angular');
require('angular-sanitize'); 
var templateUrl = require('./appSelectCompany.ng.html');
require('./appSelectCompany.less');
var svc = require('_services/commonDataSvc.js');

var app = angular.module("app-select-company", []); 
 

app.directive('appSelectCompany', function() {
  return {
    restrict: 'E',
    templateUrl: templateUrl,
    scope: {
      ngModel : "="
    },
    controller: ["$scope", "$http", function($scope, $http){
      $scope.vm = {}; 	
	    $scope.companies = [];
      $scope.vm.model = "";
      $scope.extraClass = {};
      $scope.location = {
        url: window.location.origin
      };

	    $scope.find = function(s){
				
				if (s === '') {
					$scope.companies = [];
				}

				else {
      		 svc.findCompanies(s, $http).then(function(response) { 
       		 $scope.companies = response.data.items;
       		 });
      	}
	    };

  	  $scope.$watch("vm.model", function(newValue){
  	  	$scope.ngModel = newValue;
  	  });   

    }]
  }
});





/** WEBPACK FOOTER **
 ** ./_directives/appSelectCompany/appSelectCompany.js
 **/